import { useEffect } from "react";

// Revokes a blob: preview URL when it changes or on unmount to avoid leaks.
export function useBlobUrlCleanup(url) {
  useEffect(() => {
    return () => {
      if (url && url.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);
}
